/*
 * Copyright © 2022 EPO: European Patent Office.
 * ALL RIGHTS RESERVED
 */

import React, { useContext } from 'react';
import IconButton from '@material-ui/core/IconButton';
import Menu from '@material-ui/core/Menu';
import MenuItem from '@material-ui/core/MenuItem';
import ListItemIcon from '@material-ui/core/ListItemIcon';
import ListItemText from '@material-ui/core/ListItemText';
import MoreVertIcon from '@material-ui/icons/MoreVert';
import EditIcon from '@material-ui/icons/Edit';
import DeleteIcon from '@material-ui/icons/Delete';
import { useTranslation } from 'react-i18next';

import { CardContext } from '../CardContext';

export default function CardMenuAction({ id }) {
  const { t } = useTranslation();
  const { anchorEl, handleEdit, handleClick, handleClose, handleDelete } = useContext(CardContext);

  return (
    <>
      <IconButton id={`${id}_menuButton`} aria-label="settings" color="primary" onClick={handleClick}>
        <MoreVertIcon />
      </IconButton>
      <Menu
        id="customized-menu"
        anchorEl={anchorEl}
        keepMounted
        open={Boolean(anchorEl)}
        onClose={handleClose}
        MenuListProps={{ id: `${id}_menu` }}
      >
        {handleEdit && (
          <MenuItem id={`${id}_menu_edit`} onClick={handleEdit} readOnly={!handleEdit}>
            <ListItemIcon>
              <EditIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={t('actions.edit')} />
          </MenuItem>
        )}
        {handleDelete && (
          <MenuItem id={`${id}_menu_delete`} onClick={handleDelete} readOnly={!handleDelete}>
            <ListItemIcon>
              <DeleteIcon fontSize="small" />
            </ListItemIcon>
            <ListItemText primary={t('actions.delete')} />
          </MenuItem>
        )}
      </Menu>
    </>
  );
}
